module.exports = __webpack_public_path__ + "img/sdlogo.70f35eb5.png";